import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import BulkUploadPopup from "../../components/BulkUploadPopup";
import { useLanguage } from "../../context/languageContext";
import { splitList } from "../../helper/listSeparator";

const AUTHOR_VALIDATION_RULES = [
    { field: 'author_name', type: 'string', message: 'Author name is required' },
    { field: 'profession_industry', type: 'array', message: 'Profession names are required' },
    { field: 'related_genres', type: 'array', message: 'Genre names are required' },
    { field: 'about_author', type: 'string', message: 'About is required' },
];

const AUTHOR_COLUMNS = [
    { key: 'author_name', label: 'Author Name' },
    { key: 'profession_industry', label: 'Profession Names' },
    { key: 'related_genres', label: 'Genre Names' },
    { key: 'about_author', label: 'About' },
];

const BulkUploadAuthor = ({ isPopupVisible, handleClosePopup, onSuccess }) => {
    const { adminInfo } = useLanguage();
    const [loading, setLoading] = useState(false);

    // Several values in one cell are separated by ";" — a comma belongs to the
    // value ("Martin Luther King, Jr.", "Everyone Communicates, Few Connect").
    const parseListCell = splitList;

    const createProfessionObjects = (professions) => professions.map((profession) => ({ professionName: profession }));
    const createGenreObjects = (genres) => genres.map((genre) => ({ genreName: genre }));

    const transformedRowValues = (row) => ({
        author_name: row.author_name?.trim() || "",
        about_author: row.about_author?.trim() || "",
        profession_industry: createProfessionObjects(parseListCell(row.profession_industry)),
        related_genres: createGenreObjects(parseListCell(row.related_genres)),
    });

    const getTableRowValues = (value) => (
        <>
            <td className="max_width">{value.author_name}</td>
            <td className="max_width">
                {value.profession_industry?.map((item, index) => (
                    <li className="list_styled" key={index}>{item.professionName}</li>
                ))}
            </td>
            <td className="max_width">
                {value.related_genres?.map((item, index) => (
                    <li className="list_styled" key={index}>{item.genreName}</li>
                ))}
            </td>
            <td className="max_width">{value.about_author}</td>
        </>
    );

    const handleAddAuthorData = async (values) => {
        setLoading(true);
        try {
            if (values.length >= 50) {
                toast.info("You can only add up to 50 favorite authors at a time");
                setLoading(false);
                return;
            };

            const headers = { Authorization: `Bearer ${adminInfo.token}` };
            const { data: response } = await axios.post(`${process.env.REACT_APP_API_ROOT}/api/admin/favorite-author/bulk-add`, { values }, { headers });

            if (response.status === true) {
                toast.success(response.message);
                handleClosePopup();
                onSuccess();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("handleAddAuthorData catch error::", error);
            const errorMessage = error.response?.data?.message || error.response?.data?.error;
            toast.error(errorMessage);
        } finally {
            setTimeout(() => setLoading(false), 300);
        }
    };


    return (
        <BulkUploadPopup
            isPopupVisible={isPopupVisible}
            handleClosePopup={handleClosePopup}
            title="Add Favorite Authors in Bulk through CSV"
            columns={AUTHOR_COLUMNS}
            validationRules={AUTHOR_VALIDATION_RULES}
            transformedRowValues={transformedRowValues}
            getTableRowValues={getTableRowValues}
            onSubmit={handleAddAuthorData}
            label="Favorite Authors"
            isSubmit={loading}
        />
    );
};

export default BulkUploadAuthor;
